'use client';

import { InformationsForm } from '@prismo-io/feature-organization/forms/informations';
import { type ComponentProps, type FC, useCallback } from 'react';
import { useSetOrganizationMetadata } from './use-set-organization-metadata';

type FormProps = ComponentProps<typeof InformationsForm>;

type Props = Omit<FormProps, 'onSubmit'>;

export const InformationsFormWrapper: FC<Props> = (props) => {
  const { trigger: setMetadata } = useSetOrganizationMetadata();

  const onSubmit: FormProps['onSubmit'] = useCallback(
    (data) => {
      setMetadata(data);
    },
    [setMetadata]
  );

  return <InformationsForm {...props} onSubmit={onSubmit} />;
};
